import api from "../api/dataSource";
import {Card, CardBody, CardTitle} from "reactstrap";
import withReactContent from 'sweetalert2-react-content'
import {Component} from "react";
import Swal from 'sweetalert2'
const MySwal = withReactContent(Swal)

class Solicitud extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agencias: [],
      agenciasFilter: [],
      filtro: '',
      modalShow: false,
      solicitud: {
        empresa: '',
        email: '',
        nombreDominio: '',
        tieneHosting: 'no',
        tieneContenido: '',
        tieneEstructura: '',
        referencia: '',
        tipoPagina: '',
        comentario: ''
      },
      errores: {
        empresa: '',
        email: '',
        nombreDominio: '',
        tieneHosting: '',
        tieneContenido: '',
        tieneEstructura: '',
        referencia: '',
        tipoPagina: '',
        comentario: ''
      },
      tieneDominio: 'no'
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.limpiarCampos = this.limpiarCampos.bind(this)
    this.guardar = this.guardar.bind(this)
  }

  guardar = () => {
    const sol = this.state.solicitud
    let err = {
      empresa: '',
      email: '',
      nombreDominio: '',
      tieneHosting: '',
      tieneContenido: '',
      tieneEstructura: '',
      referencia: '',
      tipoPagina: '',
      comentario: ''
    }
    let tieneErrores = false
    if(!sol.empresa){
      err.empresa = "El campo nombre de empresa no debe ser vacio"
      tieneErrores = true
    }
    if(!sol.email){
      err.email = "El campo email no debe ser vacio"
      tieneErrores = true
    }
    if(!sol.tieneContenido){
      err.tieneContenido = "El campo tiene contenido no debe ser vacio"
      tieneErrores = true
    }
    if(!sol.tieneEstructura){
      err.tieneEstructura = "El campo tiene estructura no debe ser vacio"
      tieneErrores = true
    }
    if(!sol.tipoPagina){
      err.tipoPagina = "Este campo es requerido"
      tieneErrores = true
    }

    this.setState({
      errores : err
    })
    if(tieneErrores)
      return false

    MySwal.showLoading();
    MySwal.disableButtons();
    api.postLite(`solicitud.php?action=guardar_solicitud&p=0`, sol).then((resp) => {
      if (resp.status) {
        MySwal.fire(
          'Registro exitoso!',
          'Revisaremos su solicitud!',
          'success'
        )
        this.limpiarCampos()
      } else {
        MySwal.fire(
          'No se envió la solicitud!',
          'Error, consulte con el administrador del sitio!',
          'error'
        )
      }
    }).catch(error => {
      MySwal.close()
    }).finally(()=> {
      
    })
  }

  limpiarCampos = () => {
    this.setState({
      solicitud: {
        empresa: '',
        email: '',
        nombreDominio: '',
        tieneHosting: 'no',
        tieneContenido: '',
        tieneEstructura: '',
        referencia: '',
        tipoPagina: '',
        comentario: ''
      }
    })
  }

  handleInputChange(event) {
    const target = event.target
    const name = target.name
    const value = target.value
    this.setState(prevState => ({
      solicitud : {
        ...prevState.solicitud,
        [name]: value
      }
    }))
  }

  handleSelect(event) {    
    const target = event.target
    const name = target.name
    const value = target.value
    this.setState({
      [name]: value
    })
  }

  render(){
    return (
      <div className="container" style={{paddingTop: '100px'}}>
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody className="text-center mt-4">
                <CardTitle>
                  {/*<img src="/img/agencia.png"/>*/}
                  <h1>Formulario de Solicitud para un sitio Web</h1>
                </CardTitle>
              </CardBody>
            </Card>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody>
                <div className="card card-6">
                  <div className="card-body">
                    <form>
                      <div className="form-row">
                        <div className="name">Nombre o Empresa</div>
                        <div className="value">
                          <input value={this.state.solicitud.empresa} onChange={this.handleInputChange} className={this.state.errores.empresa !== '' ? 'input--style-error' : 'input--style-6'} type="text" name="empresa" />
                          {this.state.errores.empresa !== "" &&
                            <small className="texto-error">
                              { this.state.errores.empresa }
                            </small>
                          }
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="name">Correo Electrónico</div>
                        <div className="value">
                          <div className="input-group">
                            <input value={this.state.solicitud.email} onChange={this.handleInputChange} className={this.state.errores.email !== '' ? 'input--style-error' : 'input--style-6'} type="email" name="email" />
                            {this.state.errores.email !== "" &&
                              <small className="texto-error">
                                { this.state.errores.email }
                              </small>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="name">¿Tiene un nombre de dominio?</div>
                        <div className="value">
                          <select value={this.state.tieneDominio} name="tieneDominio" className="input--style-6" onChange={this.handleSelect}>
                            <option value="si">SI</option>
                            <option value="no">NO</option>
                          </select>
                        </div>
                      </div>
                      {this.state.tieneDominio === 'si' && <div className="form-row">
                        <div className="name">Cuál es el nombre del dominio?</div>
                        <div className="value">
                          <div className="input-group">
                            <input value={this.state.solicitud.nombreDominio} 
                                   onChange={this.handleInputChange}
                                   className={this.state.errores.nombreDominio !== '' ? 'input--style-error' : 'input--style-6'}
                                   type="text" name="nombreDominio"
                            />
                          </div>
                        </div>
                      </div>}
                      <div className="form-row">
                        <div className="name">¿Tiene un servidor hosting para alojar el sitio?</div>
                        <div className="value">
                          <div className="input-group">
                            <select value={this.state.solicitud.tieneHosting} name="tieneHosting" className="input--style-6" onChange={this.handleInputChange}>
                              <option value="si">SI</option>
                              <option value="no">NO</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="name">¿Tiene contenido (fotos, videos, textos, logos) para el sitio?</div>
                        <div className="value">
                          <div className="input-group">
                            <input value={this.state.solicitud.tieneContenido} 
                                   onChange={this.handleInputChange}
                                   className={this.state.errores.tieneContenido !== '' ? 'input--style-error' : 'input--style-6'}
                                   type="text" name="tieneContenido"
                            />
                            {this.state.errores.tieneContenido !== "" &&
                              <small className="texto-error">
                                { this.state.errores.tieneContenido }
                              </small>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="name">¿Tiene en mente una estructura para el sitio? Ej. cantidad de Páginas</div>
                        <div className="value">
                          <div className="input-group">
                            <input value={this.state.solicitud.tieneEstructura} 
                                   onChange={this.handleInputChange}
                                   className={this.state.errores.tieneEstructura !== '' ? 'input--style-error' : 'input--style-6'}
                                   type="text" name="tieneEstructura"
                            />
                            {this.state.errores.tieneEstructura !== "" &&
                              <small className="texto-error">
                                { this.state.errores.tieneEstructura }
                              </small>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="name">¿Tiene algún sitio de referencia en la web?</div>
                        <div className="value">
                          <div className="input-group">
                            <input value={this.state.solicitud.referencia} 
                                   onChange={this.handleInputChange}
                                   className='input--style-6'
                                   type="text" name="referencia"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="name">¿Prefiere usar un CMS Ej. Wordpress o Prefiere un desarrollo a medida?</div>
                        <div className="value">
                          <div className="input-group">
                            <input value={this.state.solicitud.tipoPagina}
                                   onChange={this.handleInputChange}
                                   className={this.state.errores.tipoPagina !== '' ? 'input--style-error' : 'input--style-6'}
                                   type="text" name="tipoPagina"
                            />
                            {this.state.errores.tipoPagina !== "" &&
                              <small className="texto-error">
                                { this.state.errores.tipoPagina }
                              </small>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="name">¿Algún comentario adicional?</div>
                        <div className="value">
                          <div className="input-group">
                            <textarea
                              value={this.state.solicitud.comentario}
                              onChange={this.handleInputChange}
                              className="textarea--style-6"
                              name="comentario"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      {/* <div className="form-row">
                        <div className="name">Upload CV</div>
                        <div className="value">
                          <div className="input-group js-input-file">
                            <input className="input-file" type="file" name="file_cv" id="file" />
                              <label className="label--file" htmlFor="file">Choose file</label>
                              <span className="input-file__info">No file chosen</span>
                          </div>
                          <div className="label--desc">Upload your CV/Resume or any other relevant file. Max file size
                            50 MB
                          </div>
                        </div>
                      </div> */}
                    </form>
                  </div>
                  <div className="card-footer">
                    <button
                      style={{color: 'white', background: '#4272d7'}}
                      className="btn btn--radius-2 btn--blue"
                      onClick={()=>this.guardar()}
                    >Enviar Solicitud</button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
        <br/><br/><br/>
        <br/><br/><br/>
      </div>
    )
  }
}

export default Solicitud;
